import Cookies from 'js-cookie';

const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_SITE_DOMAIN || '';
const COOKIE_PATH = '/';

const MAIN_COOKIE = process.env.NEXT_PUBLIC_COOKIE_NAME || 'cr_prod_token';
const REFRESH_COOKIE = process.env.NEXT_PUBLIC_REFRESH_COOKIE_NAME || 'cr_prod_refresh_token';
const EXPIRE_COOKIE = process.env.NEXT_PUBLIC_EXPIRE_COOKIE_NAME || 'cr_prod_expire_token';

export const authMiddleware = (storeAPI: any) => (next: any) => (action: any) => {
  if (action.type.endsWith('/rejected')) {

    if (
      action.payload?.status === 'failed' &&
      action.payload?.message === 'Expire token is not fount' &&
      action.payload?.action === 'logout'
    ) {
      const removeOptions = {
        domain: COOKIE_DOMAIN,
        path: COOKIE_PATH,
      };
      Cookies.remove(MAIN_COOKIE, removeOptions);
      Cookies.remove(REFRESH_COOKIE, removeOptions);
      Cookies.remove(EXPIRE_COOKIE, removeOptions);
      window.location.href = '/'; 
    }
  }

  return next(action);
};
